// Filter dropdowns on the inspiration archive and the news archive block. The
// toggle and its panel are adjacent siblings; the panel is revealed by the
// `open` class and overlays the card grid, so only one may be open at a time.
const toggles = Array.from(document.querySelectorAll('.filter__toggle'));

function panelFor(toggle) {
  return toggle.nextElementSibling;
}

function closeFilter(toggle) {
  panelFor(toggle).classList.remove('open');
  toggle.setAttribute('aria-expanded', 'false');
}

function openFilter(toggle) {
  toggles.forEach((other) => {
    if (other !== toggle) closeFilter(other);
  });
  panelFor(toggle).classList.add('open');
  toggle.setAttribute('aria-expanded', 'true');
}

function isOpen(toggle) {
  return toggle.getAttribute('aria-expanded') === 'true';
}

if (toggles.length) {
  toggles.forEach((toggle) => {
    toggle.setAttribute('aria-expanded', 'false');

    toggle.addEventListener('click', function () {
      if (isOpen(toggle)) {
        closeFilter(toggle);
      } else {
        openFilter(toggle);
      }
    });
  });

  document.addEventListener('pointerdown', function (e) {
    toggles.forEach((toggle) => {
      if (isOpen(toggle) && !toggle.parentElement.contains(e.target)) {
        closeFilter(toggle);
      }
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;

    toggles.forEach((toggle) => {
      if (isOpen(toggle)) {
        closeFilter(toggle);
        toggle.focus();
      }
    });
  });
}
